// extracted by mini-css-extract-plugin
export default {"info":"BlurDataInfo_info__X5-kv","link":"BlurDataInfo_link__gqvgc"};